import { render, staticRenderFns } from "./AuditStatusGroupPostComment.vue?vue&type=template&id=14e21d25&"
import script from "./AuditStatusGroupPostComment.vue?vue&type=script&lang=js&"
export * from "./AuditStatusGroupPostComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports